import Splide, {Options} from "@splidejs/splide";
import { carouselTranslation, setCarouselHeight, setCarouselHeightWhenInViewport } from '@utils/carousel';
import { debounce } from '@utils/debounce';

export const useLinkCarousel = () => {
  const linkCarouselOptions: Options = {
    type: 'loop',
    speed: 500,
    start: 0,
    focus: 0,
    omitEnd: true,
    perMove: 1,
    gap: '2rem',
    easing: 'ease',
    drag: true,
    flickPower: 150,
    flickMaxPages: 1,
    keyboard: true,
    updateOnMove: true,
    pagination: false,
    arrows: false,
    perPage: 1,
    mediaQuery: 'min',
    breakpoints: {
      576: {
        perPage: 1,
        gap: '3rem'
      },
      768: {
        perPage: 3,
        gap: '4rem'
      },
      992: {
        gap: '6rem'
      },
    },
    classes: {
      arrow: 'link-carousel-block__arrow splide__arrow',
      prev: 'link-carousel-block__arrow--prev splide__arrow--prev ',
      next: 'link-carousel-block__arrow--next splide__arrow--next '
    },
  }

  const setUpCarousel = (linkCarousel: HTMLElement): void => {
    const carouselSection = linkCarousel.querySelector(".link-carousel-block__carousel") as HTMLElement;
    const carouselId: string = carouselSection.id;

    // Set carousel translations
    linkCarouselOptions.i18n = carouselTranslation(linkCarousel);
    
    const carousel: Splide = new Splide(`#${carouselId}`, linkCarouselOptions);
    
    carousel.on('mounted', () => {
      // Ugly hack to ensure the carousel is loaded before calculating the height
      setTimeout(() => {
        setCarouselHeight(linkCarousel);
      }, 1000);
    });

    carousel.mount();

    // Go to the previous slide
    linkCarousel.querySelectorAll('button.link-carousel-block__arrow--prev')?.forEach((arrowElement) => {
      arrowElement.addEventListener('click', () => {
        carousel.go('<');
      });
    });

    // Go to the next slide
    linkCarousel.querySelectorAll('.link-carousel-block__arrow--next')?.forEach((arrowElement) => {
      arrowElement.addEventListener('click', () => {
        carousel.go('>');
      });
    });

    setCarouselHeightWhenInViewport(linkCarousel);
  }

  const linkCarousels = document.querySelectorAll('.link-carousel-block');

  if (linkCarousels.length > 0) {
    linkCarousels.forEach(linkCarousel => {
      setUpCarousel(linkCarousel as HTMLElement);
    });
  }

  // Resize event listener
  window.addEventListener('resize', debounce(() => {
    linkCarousels.forEach(generalCarousel => {
      setCarouselHeight(generalCarousel as HTMLElement);
    });
  }, 250));
}

document.addEventListener('DOMContentLoaded', (): void => {
  useLinkCarousel();
});